module.exports = {"title":"Manage users - FR","user":"User - FR","email":"Email - FR","role":"Role - FR","addNewUser":"Add new user - FR","modalTitle":"Delete user - FR","modalDescription":"Are you sure you want to delete this user - FR","msg":{"yay":"Yay! - FR","oops":"Oops! - FR","success":"User has been updated successfully. - FR"},"helps":[{"title":"Tip","content":"<p>Users are individuals who can sell tickets and/or manage your account on your behalf.</p>"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientPreferences/ManageUsers/locales/fr.json
// module id = 1479
// module chunks = 0